// extracted by mini-css-extract-plugin
export var heroImage = "_i8-1";
export var modal = "_i8-0";